import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton } from '@mui';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import './top-bar-navigation.scss';

const Navigation = ({ next, previous, today, selectedDate }) => (
  <div styleName="navigation-container">
    <div styleName="navigation-button">
      <Button plain onClick={today} variant="outlined">Today</Button>
    </div>
    <IconButton onClick={previous} size="small" aria-label="Previous">
      <KeyboardArrowLeft />
    </IconButton>
    <div styleName="navigation-sep" />
    <IconButton onClick={next} size="small" aria-label="Next">
      <KeyboardArrowRight />
    </IconButton>
    {/* role="status" aria-live="polite" - Previous/Next/Today change this with no other
        feedback for a screen reader user, who can't see the calendar grid update. */}
    <div aria-live="polite" role="status" styleName="navigation-date">{selectedDate.format('MMMM YYYY')}</div>
  </div>
);

Navigation.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  selectedDate: PropTypes.object,
  today: PropTypes.func
};

export default memo(Navigation);
